import {
  GET_WEB_RTC_STATS_REQUEST,
  GET_WEB_RTC_STATS_SUCCESS,
  GET_WEB_RTC_STATS_FAILURE
} from 'actions/api/stats'
import { flatten } from 'lodash'


const parseStats = (stats) => {
  const data = {}
  Object.keys(stats).forEach(key => {
    data[key] = flatten(stats[key].map(d => JSON.parse(d)))
  })
  return data
}

export const initialState = {
  data: null,
  loading: false,
  statusCode: null,
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_WEB_RTC_STATS_REQUEST: {
      return {
        ...state,
        loading: true,
        data: null
      }
    }

    case GET_WEB_RTC_STATS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error,
        statusCode: action.status
      }
    }

    case GET_WEB_RTC_STATS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: parseStats(action.response),
        error: null,
        statusCode: null
      }
    }
  }
  return state
}
